export default "__VITE_ASSET__43c7a5e3__"